<template>
  <div>
    <div v-if="!dataStore.versionbool && dataStore.oneFileSelected" class="no-data-screen">
      {{ t('result_view.version_history.no_data_selected') }}
    </div>
    <div v-else-if="!dataStore.versionbool && !dataStore.oneFileSelected" class="no-data-screen">
      {{ t('result_view.version_history.no_data') }}
    </div>
    <div v-else class="tab-view-version">
      <table class="version-table">
        <tr class="version-table-header">
          <th class="version-table-header-item entry-left-edge">{{ t('result_view.version_history.efr_version') }}</th>
          <th class="version-table-header-item">{{ t('result_view.version_history.countries') }}</th>
          <th class="version-table-header-item">{{ t('result_view.version_history.date') }}</th>
          <th class="version-table-header-item" style="width: 30%;">{{ t('result_view.version_history.time') }}</th>
        </tr>
        <tr v-for="(version, index) in dataStore.versions" :key="index" class="version-entry">
          <td class="version-entry-item entry-left-edge">{{ version.EFRVersion }}</td>
          <td class="version-entry-item">
            <div class="countries">
              <div v-for="(country, idx) in version.Countries.split('-')" :key="idx" class="country-chip">
                {{ country }}
              </div>
            </div>
          </td>
          <td class="version-entry-item">{{ version.firstcalled.substr(0, 10) }}</td>
          <td class="version-entry-item entry-right-edge">{{ version.firstcalled.substr(11) }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script setup>
import { useDataStore } from '@/stores/dataStore.js'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const dataStore = useDataStore()
</script>

<style scoped>
.no-data-screen {
  font-size: 20px;
  text-align: center;
  margin-top: 20px;
}

.tab-view-version {
  padding: 20px;
}

.version-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 5px;
}

.version-table-header {
  background-color: var(--background-color-secondary);
  color: var(--text-primary-color);
}
.version-table-header-item {
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  padding: 0 0 0 15px;
}

.version-entry {
  background-color: var(--light-grey-background-color);
  font-weight: 400;
  font-size: 15px;
  height: 46px;
  margin-bottom: 5px;
}
.version-entry-item {
  padding-left: 15px;
}

.countries {
  display: flex;
  gap: 10px;
}

.country-chip {
  background-color: var(--country-chip-background-color);
  color: black;
  height: 22px;
  width: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 61px;
  font-size: medium;
}

.entry-left-edge {
  border-radius: 4px 0 0 4px;
}

.entry-right-edge {
  border-radius: 0 4px 4px 0;
}
</style>